<div class="toggle-switch">
    <input (change)="onCheckboxChange($event,params.data)" type="checkbox" [checked]="params.data.FBMEnabled == 1" id="fbmEnabled{{params.data.locationid}}" />
    <label for="fbmEnabled{{params.data.locationid}}">Toggle</label>
</div>